module.exports = __webpack_public_path__ + "img/horizontal_7_3_6005.12873aaa.png";